import { GenericService } from '@/services/api/generic.service';
import { EncounterType } from '@/custom/menicon/models';

export class EncounterTypesService extends GenericService<EncounterType> {
  constructor() {
    super('/menicon/v1/encounter-types');
  }
}
